export default __webpack_public_path__ + "static/media/cup_dark.d69cc55e.svg";